module.exports = __webpack_public_path__ + "img/vip.2953f3a7.jpg";